// src/config/apiConfig.js
// Central place to manage backend base URL
// Priority: env -> window override -> live API.
// `npm start` gets http://localhost:8080 from .env.development; `npm run build` ignores that file, so
// builds use the live API. Don't switch the address here by hand.
const API_BASE_URL =
  process.env.REACT_APP_API_BASE_URL ||
  (typeof window !== "undefined" && window.__API_BASE_URL__) ||
  "https://api.iotrips.in";
export default API_BASE_URL;
